// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__LZZmC","grid":"search_grid__39PSN","searchWrapper":"search_searchWrapper__1tsz6 page_searchWrapper__1hpSp"};